export enum Role {
  CAPTAIN = 'captain',
  CHARITY = 'charity',
  PARTNER = 'partner',
  DRIVER = 'driver',
  STORE = 'store',
}
